// Paletas precargadas de "Nova" (15 años, tema oscuro de noche).
// Nota: en estas paletas "primario" es un tono CLARO (títulos sobre fondo oscuro).
const FUENTES = {
  display: '"Bebas Neue", Impact, sans-serif',
  cuerpo: '"Manrope", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "medianoche",
    nombre: "Medianoche",
    tema: {
      colores: {
        fondo: "#12101A",
        fondoAlt: "#1A1724",
        texto: "#F2EDE6",
        textoSuave: "#B9B2A8",
        textoTenue: "#7E7883",
        primario: "#E9DCC8",
        primarioSuave: "#241F31",
        acento: "#D4A24E",
        borde: "rgba(233, 220, 200, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "vino",
    nombre: "Vino",
    tema: {
      colores: {
        fondo: "#1A0E13",
        fondoAlt: "#241119",
        texto: "#F6ECEF",
        textoSuave: "#C4AEB7",
        textoTenue: "#8A737D",
        primario: "#EFD3DC",
        primarioSuave: "#2E1520",
        acento: "#C9A227",
        borde: "rgba(239, 211, 220, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "esmeralda",
    nombre: "Esmeralda",
    tema: {
      colores: {
        fondo: "#0C1512",
        fondoAlt: "#122019",
        texto: "#EBF2EC",
        textoSuave: "#A8BCAF",
        textoTenue: "#6E8377",
        primario: "#D9EBDD",
        primarioSuave: "#16281E",
        acento: "#4FAE85",
        borde: "rgba(217, 235, 221, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
];
